// @ts-nocheck
import styled from 'styled-components';

export const MapPopupContentStyle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  .cartographyMapPopupContent {
    &__item {
      &Container {
        display: flex;
        flex-direction: column;
        gap: 1.5px;
      }
      &Label {
        color: ${props => props.theme.uiColors.selectorLabel};
        font-family: ${props => props.theme.fontRegular};
        font-size: ${props => props.theme.fontSizeXXS};
      }
      &Value {
        color: ${props => props.theme.uiColors.textBodyDefault};
        font-family: ${props => props.theme.fontSemiBold};
        font-size: ${props => props.theme.fontSizeS};
      }
    }
    &__metricContainer {
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      gap: 4px;
      padding: 6px 8px;
      background-color: ${props => props.theme.uiColors.cardItemBackground};
    }
  }
`;
